import { getContrastRatio } from "@mui/system";

export function getContrastingTextColor(bg_color: string, black = "#000", white = "#fff"): string {
  if (!bg_color.trim()) return white;
  const constrast_ratio = getContrastRatio(bg_color, white);
  // 3:1 contrast is the WCAG 2.1 minimum ratio
  // Buuuut we need a lower limit, plus we prefer white text
  return constrast_ratio > 2.28 ? white : black;
}
